const cryptoJs = require('crypto-js');

module.exports = {
  encrypt(key, data) {
    const encryptedJs = cryptoJs.AES.encrypt(data, key).toString();
    return encryptedJs;
  },
};
